var testi_carousels = document.querySelectorAll(".testimonials--body.swiper-container");

testi_carousels.forEach((carou) => {
  new Swiper(carou, {
    // Optional parameters
    direction: "horizontal",
    slidesPerView: 3,
    speed: 1000,
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      800: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1100: {
        slidesPerView: 3,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
      prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
    },
  });
});